import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import FlashCoachLogo from "../components/_Icons/FlashCoachLogo";
import HelpNavigation from "../components/HelpNavigation/HelpNavigation";
import NotificationPopover from "../components/NotificationPopover";
import UserProfilePopover from "../components/UserProfilePopover";
import {
  getHeaderDisplayRole,
  IsCoach,
  IsCoachee,
} from "../config/Roles";
import AuthApi from "../context/AuthApi";
import { getLocalValue } from "../utils/auth";
import styles from "./DashboardLayout.module.scss";

export function DashboardLayoutWithoutSidebar({
  appBarContent,
  contentClass,
  ...props
}) {
  const Auth = useContext(AuthApi);
  const [drawerIsOpen, setDrawerIsOpen] = useState(true);
  const [anchorElNotification, setAnchorElNotification] = useState(null);
  const [anchorElUserProfile, setAnchorElUserProfile] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const notificationOpen = Boolean(anchorElNotification);
  const userProfileOpen = Boolean(anchorElUserProfile);

  useEffect(() => {
    const user = {
      fullName: getLocalValue("u_fullname"),
      userId: getLocalValue("employee_id"),
      role: getHeaderDisplayRole(),
    };
    setUserInfo(user);
  }, [Auth]);

  // open notification dialog
  const handleNotificationClick = event => {
    setAnchorElNotification(event.currentTarget);
  };

  // close notification dialog
  const handleNotificationClose = () => {
    setAnchorElNotification(null);
  };

  // open UserProfile dialog
  const handleUserProfileClick = event => {
    setAnchorElUserProfile(event.currentTarget);
  };

  // close UserProfile dialog
  const handleUserProfileClose = () => {
    setAnchorElUserProfile(null);
  };

  return (
    <div className={styles.layoutWrapper}>
      {(IsCoach() || IsCoachee()) && (
        <NotificationPopover
          open={notificationOpen}
          anchorEl={anchorElNotification}
          onClose={handleNotificationClose}
        />
      )}

      <UserProfilePopover
        open={userProfileOpen}
        anchorEl={anchorElUserProfile}
        onClose={handleUserProfileClose}
      />
      <div className={classNames(styles.appBar)} style={{ top: 0 }}>
        <div className={styles.appBarContent}>
          {/* <div className={styles.drawerHeader}>
            <div className={styles.drawerLogo}>
              <FlashCoachLogo />
            </div>
          </div> */}
          <div
            className={classNames(styles.appBarContentLeft, styles.appBarLeft)}
          >
            <div style={{ width: "160px" }}>
              <FlashCoachLogo />
            </div>
          </div>
          <div className={styles.appBarContentRight}>
            <div className={styles.helpNavigationMenu}>
              <HelpNavigation />
            </div>
            {(IsCoach() || IsCoachee()) && (
              <div
                className={styles.notificationButton}
                onClick={handleNotificationClick}
              >
                <NotificationsNoneIcon color="inherit" />
              </div>
            )}
            <div
              className={styles.userDropdown}
              onClick={handleUserProfileClick}
            >
              {userInfo && (
                <>
                  <div className={styles.userDropdownContent}>
                    <div className={styles.userDropdownName}>
                      {userInfo.fullName}
                    </div>
                    <div className={styles.userDropdownID}>
                      ID{userInfo.userId}
                    </div>
                    {userInfo.role && (
                      <div className={styles.userDropdownRole}>
                        ROLE {userInfo.role}
                      </div>
                    )}
                  </div>
                </>
              )}

              <div className={styles.dropdownButton}>
                {anchorElUserProfile ? (
                  <KeyboardArrowUpIcon color="inherit" />
                ) : (
                  <KeyboardArrowDownIcon color="inherit" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={classNames(styles.contentWrapper)}
        style={{ paddingTop: 0, height: "auto", width: "100%" }}
      >
        {/* content */}
        <div className={classNames(styles.content, contentClass)}>
          {props.children}
        </div>
      </div>
    </div>
  );
}
